
export default {
  name: 'CookieBanner',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    customizeCookies() {
      this.$emit('customize-cookies');
    },
    acceptAllCookies() {
      const preferences = {
        technical: true,
		analytics: true,
		profiling: true
      };
      this.$session.set('cookie_accepted', true);
      this.$session.set('cookie_preferences', preferences);
      this.$emit('cookies-accepted');
    },
    rejectCookies() {
      const preferences = {
        technical: true,
		analytics: false,
		profiling: false
      };
      this.$session.set('cookie_accepted', true);
      this.$session.set('cookie_preferences', preferences);
      this.$emit('cookies-rejected');
    }
  }
}
